<template>
  <div class="flex flex-col gap-y-3">
    <div :class="tooltip ? 'flex items-center gap-2' : ''">
      <label v-if="formElement.properties.label">{{ formElement.properties.label }} </label>
      <VcTooltip
        v-if="!!tooltip"
        placement="right"
        hover
        width="max-content"
        flip-options="{ fallbackPlacements: ['top', 'bottom'] }"
      >
        <template #trigger>
          <VcIcon name="information-circle" class="" :size="18"></VcIcon>
        </template>
        <template #content>
          {{ tooltip }}
        </template>
      </VcTooltip>
    </div>
    <div>
      <div class="flex flex-col gap-3 md:flex-row">
        <template v-for="(item, index) in formElement.properties.items" :key="index">
          <VcRadioButton
            v-model="model"
            :name="formElement.key"
            :value="item.value"
            :label="item.caption"
            @change="(newValue: Event) => validate(newValue)"
          />
        </template>
      </div>
      <VcInputDetails class="mt-2" :message="message" :error="error" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from "vue";
import { FormValidator } from "../forms-sdk";
import type { ElementValidationResult } from "../forms-sdk";
import type { ExtendedFormElement } from "../types";

interface IProps {
  formElement: ExtendedFormElement;
  tooltip?: string;
  errorMessage?: ElementValidationResult;
}

interface IEmits {
  (event: "update:error-message", error: ElementValidationResult): void;
}

const emit = defineEmits<IEmits>();
const props = defineProps<IProps>();
const model = defineModel<string>();

const elementValidationResult = ref<ElementValidationResult>({ valid: true, message: "" });
const message = computed(() => elementValidationResult.value?.message || props.errorMessage?.message);
const error = computed(() => !!elementValidationResult.value?.message || !!props.errorMessage?.message);

const formValidator = new FormValidator(props.formElement);
function validate(event: Event): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elementValidationResult.value = formValidator.validate((event?.target as any)._value);
  emit("update:error-message", elementValidationResult.value);
}
onBeforeMount(() => {
  model.value = props.formElement.properties.items.find((item) => item.checked)?.value;
});
</script>
